export default "__VITE_ASSET__C8R3dEDS__"